<template>
  <block-layout-wrapper classes="!py-0 !pt-4">
    <div class="hidden lg:block">
      <div class="flex items-center h-full">
        <div class="">
          <Link href="/">
          <img :src="getImageUrl('logos/emt_prep_logo.svg')"
            class="max-w-[176px] md:max-w-[120px] xl:max-w-[176px]" />
          </Link>
        </div>
        <div class="flex gap-10 xl:gap-14 justify-center w-full font-inter font-semibold">
          <template v-for="link in navLinks">
            <header-link-dropdown v-if="link.target === 'dropdown'" :links="link.links"
              :title="link.title" />
            <Link v-else
              :class="'hover:font-bold hover:border-b-neutral-100 border-b-2 mt-2 border-transparent whitespace-nowrap' + ' ' + (link.active ? '!border-primary-default' : '')"
              :href="link.dest" class="lg:text-sm xl:text-base">{{ link.title }}
            </Link>
          </template>
        </div>
        <div>
          <div class="flex gap-4 items-center justify-center">
            <a :href="$page.props.site_config.backend_app_login_route"
              class="btn w-[131px] btn-neutral-outline lg:!w-[100px] xl:!w-[131px]">
              Log in
            </a>
            <a :href="route('pricing')"
              class="btn w-[131px] btn-dark lg:!w-[100px] xl:!w-[131px]">
              Sign Up
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- Mobile Navbar -->
    <div class="flex w-full items-center justify-between lg:hidden">
      <Link href="/">
      <img :src="getImageUrl('logos/emt_prep_logo.svg')" class="h-[30px]" />
      </Link>
      <div class="flex items-center gap-3">
        <div>
          <div class="hidden sm:flex gap-4 items-center justify-center">
            <a :href="$page.props.site_config.backend_app_login_route"
              class="btn w-[100px] btn-neutral-outline">
              Log in
            </a>
            <a :href="route('pricing')" class="btn w-[100px] btn-dark">
              Sign Up
            </a>
          </div>
        </div>
        <slide-over-menu open-from="right">
          <template #trigger>
            <svg fill="none" height="40" viewBox="0 0 40 40" width="40"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8 12H32C32.5523 12 33 12.4477 33 13C33 13.5523 32.5523 14 32 14H8C7.44772 14 7 13.5523 7 13C7 12.4477 7.44772 12 8 12Z"
                fill="black" />
              <path
                d="M8 19H32C32.5523 19 33 19.4477 33 20C33 20.5523 32.5523 21 32 21H8C7.44772 21 7 20.5523 7 20C7 19.4477 7.44772 19 8 19Z"
                fill="black" />
              <path
                d="M8 26H32C32.5523 26 33 26.4477 33 27C33 27.5523 32.5523 28 32 28H8C7.44772 28 7 27.5523 7 27C7 26.4477 7.44772 26 8 26Z"
                fill="black" />
            </svg>

          </template>
          <template #menu_content>
            <div class=" px-4 py-6 flex h-full flex-col bg-background-dark">
              <div class="flex flex-col p-4 leading-[53px]">
                <template v-for="link in navLinks" v-show="link.visible">
                  <!-- TODO: Style these dropdowns when there is a design or feedback on contents. -->
                  <header-link-dropdown v-if="link.target === 'dropdown'"
                    :links="link.links" :title="link.title" />
                  <Link v-else
                    :class="'tracking-tight border-b-4 border-transparent whitespace-nowrap' + ' ' + (link.active ? '!border-primary-default' : '')"
                    :href="link.dest">{{ link.title }}
                  </Link>
                </template>
              </div>
              <div class="flex sm:hidden flex-col w-full gap-4 px-4">
                <a :href="$page.props.site_config.backend_app_login_route"
                  class="btn !w-[100px] btn-neutral-outline">
                  Log in
                </a>
                <a :href="route('pricing')" class="btn !w-[100px] btn-dark">
                  Sign Up
                </a>
              </div>
            </div>
          </template>
        </slide-over-menu>
      </div>
    </div>
  </block-layout-wrapper>
</template>

<script>
import HeaderLinkDropdown from "@/Components/HeaderLinkDropdown.vue";
import SlideOverMenu from "@/Components/SlideOverMenu.vue";
import BlockLayoutWrapper from "@/Layouts/BlockLayoutWrapper.vue";

export default {
  name: 'FrontendHeader',
  components: { BlockLayoutWrapper, SlideOverMenu, HeaderLinkDropdown },
  data() {
    return {
      navLinks: [
        { title: 'Pricing', target: 'route', dest: route('pricing') },
        { title: 'Group Plans', target: 'route', dest: route('bulk-memberships') },
        { title: 'Resources', target: 'route', dest: route('resources.index') },
        { title: 'About', target: 'route', dest: route('about-us') },
        {
          title: 'Learn More', target: 'dropdown', dest: route('about-us'), links: [
            {
              title: 'AI Tutor', target: 'route', dest: route('ai-tutor'),
            },
            {
              title: 'NREMT Sim Exam', target: 'route', dest: route('nremt-sim-exam'),
            },
            {
              title: 'Progress Tracking', target: 'route', dest: route('progress-tracking'),
            },
            {
              title: 'Mobile App', target: 'route', dest: route('mobile-app'),
            },
          ]
        },
        { title: 'FAQ', target: 'route', dest: route('faqs') },
      ],
    }
  },
}
</script>
